import { render } from "./EditMembership.vue?vue&type=template&id=feedba54"
import script from "./EditMembership.vue?vue&type=script&lang=js"
export * from "./EditMembership.vue?vue&type=script&lang=js"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__